import $ from 'jquery';
import 'sumoselect/jquery.sumoselect.js';

const select = (node) => {
  const $node = $(node);
  $node.SumoSelect({
    placeholder: $node.attr('placeholder') ? $node.attr('placeholder') : 'Выберите',
    forceCustomRendering: true,
    captionFormat: '{0} Выбрано',
    captionFormatAllSelected: '{0} Все выбраны!',
  });
};

const initSelect = () => {
  const nodes = Array.from(document.querySelectorAll('.jsSelect'));
  nodes.forEach(select);
};

export { select, initSelect };
